<div>
  <ul>
    <li>Name: {{ contact?.firstName }} {{ contact?.lastName }}</li>
    <li>Company Name: {{ contact?.companyName }}</li>
    @if (contact?.contactType==='EMPLOYEE') {
      <li>Employee Number: {{ contact?.employeeNumber }}</li>
      <li>Location: {{ contact?.locationName }}</li>
    }
    <li></li>
  </ul>
</div>
